<span class="minfy-ui-change-request-status"
  [ngClass]="{success: status == 'Approved', light: status == 'Pending Approval', danger: status == 'Rejected'}">
  {{status}}
</span>